const BurkinaFasoSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111052)">
      <path
        d="M0 20C0 8.95437 8.95437 0 20 0C31.0456 0 40 8.95437 40 20C39.1305 20 20 22.6087 20 22.6087L0 20Z"
        fill="#D80027"
      />
      <path d="M40 20C40 31.0456 31.0456 40 20 40C8.95437 40 0 31.0456 0 20" fill="#6DA544" />
      <path
        d="M20.0003 13.043L21.511 17.6928H26.4006L22.445 20.5667L23.9558 25.2169L20.0003 22.343L16.0448 25.2169L17.5558 20.5667L13.6001 17.6928H18.4895L20.0003 13.043Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111052">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default BurkinaFasoSvg;
